export const PHYSICAL_CARD_ACTIONS = '/YesBankRenewalManagement/PHYSICAL_CARD_ACTIONS';
export const YES_BANK_CARD_RENEWAL_MANAGEMENT_OTP_SUCCESS = '/YesBankRenewalManagement/YES_BANK_CARD_RENEWAL_MANAGEMENT_OTP_SUCCESS';
export const DEFAULT_ACTION = '/DEFAULT_ACTION';



// WEBPACK FOOTER //
// client/containers/YesBankRenewalManagement/constants.js